<ng-template #restoreConfigurationModal let-modal>
    <div class="modal">
        <div class="modal-header">
            <h4>{{ 'SHARED_RESTORE_CONFIGURATION_TITLE' | translate }}</h4>
            <button type="button" class="btn-close" (click)="modal.dismiss();"></button>
        </div>
        <div class="modal-body">
            <p>{{ 'SHARED_RESTORE_CONFIGURATION_QUESTION' | translate }}</p>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-secondary" (click)="modal.dismiss();">
                {{ 'BTN_ABORT' | translate }}
            </button>
            <button type="button" class="btn btn-success"
                    (click)="modal.close()">{{ 'SHARED_RESTORE_CONFIGURATION_ACCEPT' | translate }}
            </button>
        </div>
    </div>
</ng-template>
